<cigna-omni-comm-channel
  *ngIf="content$ | async as content"
  data-omni-qa="cigna-omni-comm-channel-che"
>
  <cigna-omni-comm-channel-header omniQaTag="omni-comm-channel-che-header">{{
    content.header
  }}</cigna-omni-comm-channel-header>
  <cigna-omni-comm-channel-subheader
    omniQaTag="omni-comm-channel-che-subheader"
    >{{ content.headerByline }}</cigna-omni-comm-channel-subheader
  >
  <cigna-omni-comm-channel-content
    [icon]="content.icon"
    [iconColors]="iconColors"
    [iconData]="iconData"
    omniQaTag="omni-comm-channel-che-content-icon"
  >
    <ng-container *ngFor="let line of content.body; index as i">
      <p
        [class.is-bold]="line.bold"
        [attr.data-omni-qa]="'omni-comm-channel-che-content-' + i"
      >
        {{ line.text }}
      </p>
    </ng-container>
  </cigna-omni-comm-channel-content>
  <cigna-omni-comm-channel-button
    (interaction)="interact(content)"
    [copy]="content.buttonText"
    omniQaTag="omni-comm-channel-che-button"
  ></cigna-omni-comm-channel-button>
</cigna-omni-comm-channel>
